<template>
  <div class="home">
    <div class="inner">
      <img src="~@/assets/images/banner.png" alt="banner">
    </div>
    <div class="scure_content" v-loading="loading">
      <el-empty v-if="(publicCourses.length==0)&&(courseVos.length==0)" description="暂无数据"></el-empty>
      <div class="inner">
        <cursor-list v-if="Array.isArray(publicCourses)&&publicCourses.length>0" :cursorList="publicCourses" cursortitletitle="公开课" @setHandleDetail="openclass"></cursor-list>
        <template v-for="(item,index) in courseVos">
          <cursor-list :key="index" v-if="Array.isArray(item.courses)&&item.courses.length>0" :cursorList="item.courses" :cursortitletitle="item.professionName" @setHandleDetail="getHandleDetail"></cursor-list>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import CursorList from "@/components/Cursor"
import {listCourse} from '@/api/home'
export default {
  name: "Home",
  data() {
    return {
      imgalt:'',
      publicCourses:[],
      courseVos:[],
      loading:false,
    };
  },
  components: {
    CursorList
  },
  created(){
    this.listCourseBox()
  },
  mounted() {
    
  },
  methods: {
    listCourseBox(){
      this.loading = true
      listCourse().then(res=>{
        this.loading = false
        if(res.code==200){
          this.publicCourses = res.data.publicCourses.map(v=>{
            return {
              cover: v.cover,
              createId: v.createId,
              createTime: v.createTime,
              description: v.description,
              id: v.id,
              teacherName: v.teacherName,
              title: v.title,
              updateId: v.updateId,
              updateTime: v.updateTime,
              classHours:v.classHours?(v.classHours/60/45)==0?'0':(v.classHours/60/45).toFixed(2):''
            }
          })
          this.courseVos = res.data.courseVos.map(v=>{
            return {...v,courses:v.courses.map(iv=>{
              return {
                cover: iv.cover,
                createId: iv.createId,
                createTime: iv.createTime,
                description: iv.description,
                id: iv.id,
                teacherName: iv.teacherName,
                title: iv.title,
                updateId: iv.updateId,
                updateTime: iv.updateTime,
                classHours: (iv.classHours/60/45)==0?'0':(iv.classHours/60/45).toFixed(2)
              }
            })}
          })
        }
      }).catch(err=>{
        console.log('woshicuowujiekou')
        this.loading = false
      })
    },
    getHandleDetail(data){
      console.log(data);
      let rourl =  this.$router.resolve({path:"/coursedetails",query:{id:data.id}});
      window.open(rourl.href);
    },
    openclass(data){
      console.log(data);
      let rourl =  this.$router.resolve({path:"/openclass",query:{id:data.id}});
      window.open(rourl.href);
    }
  },
};
</script>
<style lang="scss">
.home{
  background: #fff;
}
.scure_content{
  padding-top: 100px;
  background: #fff;
  padding-bottom: 100px;
}
</style>
